export default "__VITE_ASSET__DuiKJcw8__"